/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {IEntity} from '../../interface/IEntity';

/**
 * @deprecated
 */
export class RadioItem implements IEntity {
  id: string;
  label: string;
  picto: string;
  lock: boolean;

  /**
   * Consctuctor
   * @param id
   * @param label
   * @param picto
   */
  constructor(id: string, label?: string, picto?: string) {
    this.id = id;
    this.label = label;
    this.picto = picto;
  }

  /**
   * Return the id
   */
  getId(): string {
    return this.id;
  }

  /**
   * Return label
   */
  getLabel(): string {
    return this.label;
  }

  /**
   * Return picto
   */
  getPicto(): string {
    return this.picto;
  }

  /**
   * Return the label
   */
  toString(): string {
    return this.label;
  }

  public serialize(): any {
    return {
      id: this.id,
      label: this.label,
      picto: this.picto,
      lock: this.lock
    };
  }
}
